import React from 'react';
import { services, whyChoose } from '../mock';

const Card = ({ img, title, desc }) => (
  <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_16px_40px_rgba(0,0,0,0.1)] hover:-translate-y-1 transition-all duration-300 border border-slate-100 flex flex-col">
    <div className="h-52 overflow-hidden">
      <img src={img} alt={title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
    </div>
    <div className="p-6 flex-1 flex flex-col">
      <h3 className="text-[20px] font-bold text-slate-900 mb-3 leading-snug">{title}</h3>
      <p className="text-slate-600 text-[14.5px] leading-relaxed">{desc}</p>
    </div>
  </div>
);

const ServicesGrid = () => (
  <>
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h2 className="text-center text-[30px] md:text-[42px] font-bold text-slate-900">SaaS Product Development Services We Offer</h2>
        <p className="mt-4 text-center text-slate-600 max-w-3xl mx-auto">Our process ensures efficient, transparent delivery — from understanding your goals to designing, developing, and deploying tailored solutions with quality.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 mt-14">
          {services.map((s) => <Card key={s.title} {...s} />)}
        </div>
      </div>
    </section>
    <section className="py-20 bg-[#f6f7fb]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <h2 className="text-center text-[30px] md:text-[42px] font-bold text-slate-900">Why Choose Us as Your SaaS Development Partner?</h2>
        <p className="mt-4 text-center text-slate-600 max-w-3xl mx-auto">We combine deep expertise, agile execution, and a customer-first approach to deliver SaaS products that scale.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 mt-14">
          {whyChoose.map((s) => <Card key={s.title} {...s} />)}
        </div>
      </div>
    </section>
  </>
);

export default ServicesGrid;
